import { PaginateQuery, PaginatorModel, UnknownError } from 'symbols';
import { ClientFilterModel, ClientModel } from '../../symbols';

export class GetClientList {
  static readonly type = '[ClientList] GetClientList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<ClientFilterModel>) {
  }
}

export class GetClientListSuccess {
  static type = '[clientList] GetClientListSuccess';

  constructor(public clientList: PaginatorModel<ClientModel>, public lazy: boolean) {
  }
}

export class GetClientListError {
  static type = '[clientList] GetClientListError';

  constructor(public error: UnknownError) {
  }
}

export class ClearScrollPositionClientList {
  static type = '[clientList] ClearScrollPositionClientList';
}

export class UpdateScrollPositionClientList {
  static type = '[clientList] UpdateScrollPositionClientList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedClientId {
  static type = '[clientList] SetLastOpenedClientId';

  constructor(public contractId: string) {
  }
}
